import React, { useCallback } from 'react';
import { FaBuilding, FaPowerOff, FaUser } from 'react-icons/fa';
import logo from '../../assets/SGRLock_icon.png';
import logoSwint from '../../assets/swintLogo.svg';
import { useAuth } from '../../contexts/authContext';
import { useSteps } from '../../contexts/stepContext';
import { useAppTranslation } from '../../hooks/useAppTranslation';
import { PersonType } from '../../services/services';
import LanguageSwitch from '../LanguageSwitch';
/* Os styled-components da barra continuam morando no BodyStep porque
   compartilham a mesma grade interna (`innerGrid`) da barra de etapas e da área
   principal — é ela que mantém marca, etapas e card alinhados verticalmente. */
import {
  Brand,
  BrandDivider,
  LangSlot,
  TopBar,
  TopBarActions,
  TopBarInner,
  UserBox,
} from '../BodyStep/styles';

/**
 * Barra superior do balcão: marca, identificação do atendente e os atalhos
 * para começar uma consulta de Pessoa Física ou de Pessoa Jurídica.
 *
 * Os dois atalhos aparecem sempre, com a mesma regra dos cards da tela
 * inicial: tipo não contratado fica desabilitado.
 */
const AppHeader: React.FC = () => {
  const { companyName, signOut, userName, hasPfServices, hasPjServices } =
    useAuth();
  const { resetFlow, startFlow } = useSteps();
  const { translationPage } = useAppTranslation();
  const { tp } = translationPage(tr => tr.components.bodyStep);
  const { tp: tpFlow } = translationPage(tr => tr.components.flowChooser);

  const handleSignOut = useCallback(() => {
    resetFlow();
    signOut();
  }, [resetFlow, signOut]);

  // Inicia (ou reinicia) uma consulta do tipo escolhido, de qualquer etapa.
  const handleStart = useCallback(
    (type: PersonType) => () => startFlow(type),
    [startFlow],
  );

  return (
    <TopBar>
      <TopBarInner>
        <Brand>
          <img src={logo} alt="" />
          <BrandDivider />
          <img src={logoSwint} alt="" />
        </Brand>
        <TopBarActions>
          <UserBox>
            <strong>{userName}</strong>
            <span>{companyName}</span>
          </UserBox>
          <button
            onClick={handleStart('PF')}
            type="button"
            disabled={!hasPfServices}
            title={hasPfServices ? undefined : tpFlow('unavailable')}
          >
            <FaUser size={13} />
            {tpFlow('pfTitle')}
          </button>
          <button
            onClick={handleStart('PJ')}
            type="button"
            disabled={!hasPjServices}
            title={hasPjServices ? undefined : tpFlow('unavailable')}
          >
            <FaBuilding size={13} />
            {tpFlow('pjTitle')}
          </button>
          <button onClick={handleSignOut} type="button" data-variant="danger">
            <FaPowerOff size={14} />
            {tp('signOut')}
          </button>
          <LangSlot>
            <LanguageSwitch />
          </LangSlot>
        </TopBarActions>
      </TopBarInner>
    </TopBar>
  );
};

export default AppHeader;
